// removed by extract-text-webpack-plugin
module.exports = {"customMargin":"Mz7nHOtr8WiZdlBydaPaJ"};


//////////////////
// WEBPACK FOOTER
// ./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/vue-style-loader!./~/css-loader?{"minimize":true,"sourceMap":true,"localIdentName":"[hash:base64]","modules":true,"importLoaders":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2e52d066","scoped":false,"hasInlineConfig":false}!./~/less-loader/dist/cjs.js?{"sourceMap":true}!./src/components/error-message-modal/error-message-modal.less
// module id = zTfj
// module chunks = 1